// components/forms/FormStageNavigation.jsx
import { Button } from "@/components/ui/button";

export function FormStageNavigation({
  currentStage,
  totalStages,
  onPrevious,
  onNext,
  onSubmit,
  isSubmitting = false
}) {
  return (
    <div className="flex justify-between pt-6 border-t">
      {currentStage > 1 && (
        <Button
          type="button"
          variant="outline"
          onClick={onPrevious}
          disabled={isSubmitting}
        >
          Previous
        </Button>
      )}
      
      <div className="ml-auto flex gap-2">
        {currentStage < totalStages ? (
          <Button type="button" onClick={onNext} disabled={isSubmitting}>
            Next
          </Button>
        ) : (
          <Button 
            type="submit" 
            onClick={onSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        )}
      </div>
    </div>
  );
}